import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Start',
    component: () => import('../views/StartView.vue')
  },
  {
    path: '/ratio',
    name: 'Ratio',
    component: () => import('../views/Step1Ratio.vue')
  },
  {
    path: '/layout',
    name: 'Layout',
    component: () => import('../views/Step2Layout.vue')
  },
  {
    path: '/texts',
    name: 'Texts',
    component: () => import('../views/Step3Texts.vue')
  },
  {
    path: '/colors',
    name: 'Colors',
    component: () => import('../views/Step4Colors.vue')
  },
  {
    path: '/image',
    name: 'Image',
    component: () => import('../views/Step5Images.vue')
  },
  {
    path: '/preview',
    name: 'Preview',
    component: () => import('../views/PreviewView.vue')
  },
  {
    path: '/manual',
    name: 'Manual',
    component: () => import('../views/ManualView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
